import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import bgMusic from "../assets/background.mp3";
import backgroundImage from "../assets/landingpagenew.jpg";
import siemens_logo from "../assets/siemens_logo.svg";
import "./Dashboard.css";

const LandingPage = () => {
  const navigate = useNavigate();
  const audioRef = useRef(null);

  useEffect(() => {
    const audio = audioRef.current;

    const handleUserInteraction = () => {
      if (audio) {
        audio.muted = false; // Unmute to allow playback
        audio
          .play()
          .then(() => {
            console.log("Audio started playing");
            // Remove event listeners after successful play
            document.removeEventListener("mousemove", handleUserInteraction);
            document.removeEventListener("click", handleUserInteraction);
            document.removeEventListener("touchstart", handleUserInteraction);
          })
          .catch((error) => console.error("Audio play failed:", error));
      }
    };

    // Add event listeners
    document.addEventListener("mousemove", handleUserInteraction);
    document.addEventListener("click", handleUserInteraction);
    document.addEventListener("touchstart", handleUserInteraction);

    return () => {
      // Cleanup event listeners when the component unmounts
      document.removeEventListener("mousemove", handleUserInteraction);
      document.removeEventListener("click", handleUserInteraction);
      document.removeEventListener("touchstart", handleUserInteraction);
    };
  }, []);

  return (

    <div
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "100vh",
        color: "#ffffff",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 5%",
      }}
    >
      <div style={{ position: "absolute", top: "20px", left: "30px" }}>
        {/*<h2 style={{ fontSize: "2.9rem", fontWeight: "bold" }}>COACT</h2>*/}
         <img
          src={siemens_logo}
          alt="logo"
          style={{ width: "150px", height: "80px" }}
        /> 
      </div>

      <div style={{ maxWidth: "50%" }}>
        {/* <p className="green-gradient">
          Over{" "}
          <span className="orange">
            <strong>90% energy</strong>
          </span>{" "}
          consumed
        </p>

        <p className="green-gradient">
          by Siemens in FY24 was{" "}
        </p>
        <p className="green-gradient">from renewable sources!</p> */}




<div style={{ color: "white", fontFamily: "Arial, sans-serif" }}>
  {/* TOP TITLE */}
  <div
    style={{
      fontSize: "2rem",
      fontWeight: "300",
    }}
  >
    By combining the real and the digital worlds
  </div>

  {/* MAIN > 9 ○ % LINE */}
  <div style={{ display: "flex", alignItems: "center" }}>
    {/* > */}
    <span
      style={{
        fontSize: "8rem",
        fontWeight: "700",
        marginRight: "0.4rem",
      }}
    >
      &gt;
    </span>

    {/* 9 */}
    <span
      style={{
        fontSize: "8rem",
        fontWeight: "700",
        marginRight: "0.6rem",
      }}
    >
      9
    </span>

    {/* ---- CIRCLE WITH THICKER OUTER RING ---- */}
    <div
      style={{
        width: "90px",
        height: "90px",
        position: "relative",
        marginRight: "0.3rem",
      }}
    >
      {/* OUTER RING (THICKER NOW) */}
      <div
        style={{
          position: "absolute",
          inset: -4,
          borderRadius: "100%",
          border: "15px solid #00e6dc", // increased thickness
        }}
      ></div>

      {/* MIDDLE RING (BACKGROUND COLOR) */}
      <div
        style={{
          position: "absolute",
          inset: "10px",
          borderRadius: "50%",
          border: "5px solid #000a2c",
        }}
      ></div>

      {/* INNER FILL */}
      <div
        style={{
          position: "absolute",
          top: "22px",
          left: "22px",
          width: "46px",
          height: "46px",
          borderRadius: "50%",
          background: "#00ffb9",
        }}
      ></div>
    </div>

    {/* % */}
    <span
      style={{
        fontSize: "8rem",
        fontWeight: "700",
        marginLeft: "0.4rem",
      }}
    >
      %
    </span>
  </div>

  {/* PARAGRAPH BELOW */}
  <div
    style={{
      fontSize: "1.8rem",
      fontWeight: "300",
      marginTop: "2.2rem",
      maxWidth: "1000px",
      lineHeight: "1.4",
    }}
  >
    of our business enables customers to<br />
    achieve a positive sustainability impact
  </div>
</div>
















        

      
        <br />
        <button onClick={() => navigate("/register")} className="quiz-button">
          Take the Siemens Quiz here!
        </button>
      </div>

      

      {/* <div
        style={{
          width: "40%",
          height: "40%",
          borderRadius: "50%",
          overflow: "hidden",
        }}
      >
        <img
          src={backgroundImage}
          alt="Circular Cutout"
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      </div> */}

      {/* Background Music */}
      <audio ref={audioRef} loop muted>
        <source src={bgMusic} type="audio/mp3" />
        Your browser does not support the audio element.
      </audio>
    </div>
  );
};

export default LandingPage;
